import React from 'react';
import { CloseButton } from "@chakra-ui/react";

export default function LaunchdeckCloseButton({handleCloseModal, bg, color}) {
		return (
			<CloseButton cursor='pointer' fontSize='0.7em' boxSize='2.5em' color={color ? color : 'gray.400'} bg={bg && bg} rounded='50%' onClick={handleCloseModal} />
		)
	
}
